import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { BtnPrimary } from "@/components/Buttons";
import { Marquee } from "@/components/Marquee";
import { SECONDARY_SERVICES, MAIN_SERVICE, PROCESS } from "@/lib/data";

export default function Servicos() {
  return (
    <>
      <section className="relative overflow-hidden pt-36 md:pt-44">
        <div className="pointer-events-none absolute right-[-10%] top-0 h-[420px] w-[420px] rounded-full bg-grad opacity-[0.12] blur-[130px]" />
        <div className="mx-auto max-w-[1440px] px-6 pb-16 md:px-12">
          <Reveal>
            <span className="text-xs font-medium uppercase tracking-[0.28em] text-grad">Serviços</span>
            <h1 className="mt-5 max-w-4xl font-display text-5xl font-extrabold leading-[0.98] tracking-tight text-ink sm:text-6xl lg:text-7xl text-balance">
              Fazemos uma coisa. E fazemo-la bem: <span className="text-grad">websites</span>.
            </h1>
            <p className="mt-7 max-w-xl text-lg leading-relaxed text-muted-foreground">
              Focamo-nos apenas numa coisa: websites. É nisso que somos bons — criar o melhor website
              possível para o seu negócio, com tudo o que precisa lá dentro.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-[1440px] px-6 md:px-12">
        <Reveal className="ring-grad grid gap-10 rounded-[2rem] bg-tint p-8 md:grid-cols-2 md:items-center md:gap-16 md:p-14">
          <div>
            <span className="text-xs font-medium uppercase tracking-[0.25em] text-grad">Serviço principal</span>
            <h2 className="mt-5 font-display text-3xl font-semibold leading-[1.08] tracking-tight text-ink sm:text-4xl">{MAIN_SERVICE.title}</h2>
            <p className="mt-5 max-w-md text-lg leading-relaxed text-muted-foreground">{MAIN_SERVICE.body}</p>
          </div>
          <ul className="grid gap-3">
            {MAIN_SERVICE.points.map((p) => (
              <li key={p} className="flex items-center gap-3 rounded-2xl bg-white p-5">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-grad text-white"><Check className="h-4 w-4" /></span>
                <span className="font-medium text-ink">{p}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </section>

      <section className="mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32">
        <div className="mb-12 max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-[0.25em] text-grad">Também fazemos</span>
          <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-ink sm:text-5xl">Branding e SEO, se precisar</h2>
          <p className="mt-4 text-muted-foreground">O nosso foco é criar o seu website. Mas, se fizer sentido, também podemos cuidar da imagem da sua marca e das bases de SEO — para ficar tudo alinhado.</p>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {SECONDARY_SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }} transition={{ duration: 0.5, delay: i * 0.08 }}
                className="group flex gap-5 rounded-2xl border border-line bg-white p-7 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-transparent hover:shadow-[0_24px_50px_-24px_rgba(23,21,15,0.25)]"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-line bg-tint text-ink transition-colors duration-300 group-hover:border-transparent group-hover:bg-grad group-hover:text-white">
                  <Icon className="h-5 w-5" strokeWidth={1.6} />
                </span>
                <div>
                  <h3 className="font-display text-lg font-semibold text-ink">{s.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </section>

      <Marquee dark />

      <section className="mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32">
        <div className="mb-14 max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-[0.25em] text-grad">Como trabalhamos</span>
          <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-ink sm:text-5xl">Simples do início ao fim</h2>
        </div>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {PROCESS.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.55, delay: i * 0.08 }}
              className="rounded-2xl border border-line bg-white p-7"
            >
              <span className="font-display text-5xl font-extrabold text-grad">{p.n}</span>
              <h3 className="mt-5 font-display text-xl font-semibold text-ink">{p.t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{p.d}</p>
            </motion.div>
          ))}
        </div>
           <div className="mt-10 rounded-[2rem] border border-line bg-white p-8 md:p-10">
             <div className="grid gap-10 lg:grid-cols-[1.2fr_0.8fr] lg:items-center">

               <div>

                 <span className="text-xs font-medium uppercase tracking-[0.25em] text-grad">
                 Depois da entrega
                 </span>

                 <h3 className="mt-3 font-display text-4xl font-semibold text-ink">
                 E se quiser fazer atualizações?
                 </h3>

                 <p className="mt-6 max-w-xl text-muted-foreground leading-relaxed">
                 Depois da publicação, continuamos disponíveis para atualizar o seu
                 website sempre que precisar. Seja para alterar conteúdos, adicionar
                 novas funcionalidades ou fazer melhorias, basta contactar-nos.
                 </p>

               </div>

               <div className="space-y-4">

                 <div className="flex items-center gap-3">
                   <span className="text-grad text-xl">✓</span>
                   <span>Sem mensalidades obrigatórias</span>
                 </div>

                 <div className="flex items-center gap-3">
                   <span className="text-grad text-xl">✓</span>
                   <span>Apenas paga as alterações solicitadas</span>
                 </div>

                 <div className="flex items-center gap-3">
                   <span className="text-grad text-xl">✓</span>
                   <span>Orçamento antes de qualquer intervenção</span>
                 </div>

                 <div className="flex items-center gap-3">
                   <span className="text-grad text-xl">✓</span>
                   <span>Resposta rápida sempre que precisar</span>
                 </div>

               </div>

             </div>
           </div>

        <div className="mt-16 flex flex-col items-start gap-6 rounded-[2rem] bg-tint p-10 md:flex-row md:items-center md:justify-between md:p-14">
          <div>
            <h3 className="font-display text-3xl font-semibold text-ink md:text-4xl">Quer saber o que conseguimos fazer por si?</h3>
            <p className="mt-3 max-w-md text-muted-foreground">Conte-nos a sua ideia. Respondemos o mais rápido possível, sem compromisso.</p>
          </div>
          <BtnPrimary to="/contacto">Conte-nos a sua ideia</BtnPrimary>
        </div>
      </section>
    </>
  );
}
